export class Layout {
    layoutCompact: boolean = false;
    layoutMode: string = 'STATIC'; // STATIC, OVERLAY, HORIZONTAL, SLIM
    darkMenu: boolean = false;
    profileMode: string = 'inline'; // inline, top
    profileView: boolean = true;
    demoMenu: boolean = false;
    layoutMenu: boolean = false;
    globalSearch: boolean = false;
    footerView: boolean = false;
    settingsView: boolean = true;
    msgView: boolean = false;
    notiView: boolean = false;
    rightPanel: boolean = true;
    breadcrumb: boolean = false;
    avatar: string = "avatar.png";
}
